import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Label,
  Input,
  Button,
  // Spinner,
  Badge,
  Table,
} from "reactstrap"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import { withRouter } from "react-router-dom"
import ButtonSpinner from "../../components/ButtonSpinner"
import { connect, useSelector, useDispatch } from "react-redux"
import { get, isEmpty } from "lodash"
// import { styles } from "./Input-Select/select"
import * as salesAction from "../../store/c2FsZXM/actions"
import * as quoteAction from "../../store/YWx0ZXIgcXVvdGU/actions"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import * as quotationAction from "../../store/cXVvdGF0/actions"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import moment from "moment"

const AlterQuote = (props) => {
  const { dispatch } = props

  // let { id } = useParams()

  const title = "Alter Quote"

  // console.log(id)
  const { SearchBar } = Search

  const specificDispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      dispatch(quoteAction.loadAlterQuotePending())
    }, 1500)

    // dispatch(salesAction.loadSalesApproval())
    dispatch(salesAction.loadEmployee())
    dispatch(quoteAction.loadRecordsMetaData())
  }, [])

  //States for all the actions
  const [quoteData, setQuoteData] = useState({
    quotationFromDate: "",
    quotationToDate: "",
  })

  const handleChange = (e) => {
    setQuoteData({ ...quoteData, [e.target.name]: e.target.value })
  }

  const [btnLoader, setBtnLoader] = useState(false)
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [priority, setPriority] = useState([])
  const [service, setService] = useState([])
  const [approvalDetails, setApprovalDetails] = useState([])

  //Edit flag section
  const [leadId, setLeadId] = useState("")
  const [editFlag, setEditFlag] = useState(false)
  const handleModal = () => setEditFlag(false)
  const [fullscreen, setFullscreen] = useState(true)

  //Alter approval and recheck modal
  const [alterRemarks, setAlterRemarks] = useState("")
  const [alterApprovalView, setAlterApprovalView] = useState(false)
  const [alterRecheckView, setAlterRecheckView] = useState(false)

  const handleAlterClose = () => setAlterApprovalView(false)
  const handleAlterRecheckClose = () => setAlterRecheckView(false)

  //History modal

  const [historyForm, setHistoryForm] = useState(false)
  const handleHistoryClose = () => setHistoryForm(false)

  const [alterHistoryForm, setAlterHistoryForm] = useState(false)
  const handleAlterHistoryClose = () => setAlterHistoryForm(false)

  ///Sales Approval Store and data table

  const salesUpdate = useSelector((specificState) => specificState.sales)
  const sessionUpdate = useSelector((specificState) => specificState.session)
  const quoteUpdate = useSelector((specificState) => specificState.alterQuote)
  // const update = useSelector((specificState) => specificState)

  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )
  const { quotation_preview = [], qc_history = [] } = quotationUpdate

  const { employee_list = [] } = salesUpdate

  const { user = [] } = sessionUpdate
  const {
    alter_quote_details = [],
    alterQuoteMetaData = {},
    alter_quote_history = [],
  } = quoteUpdate

  //Date format

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  // console.log(alter_quote_details, "alter_pending_details")
  // console.log(alter_quote_history, "alter_quote_history")
  // console.log(qc_history, "qc_history")
  // console.log(update, "update")
  const reviseList = alter_quote_history
  // const reviseCountDetails = alter_quote_history

  const qcHistoryRemarks =
    reviseList.length > 0 ? reviseList[reviseList.length - 1].remarks : []

  // const qcHistoryRemarks = ""
  // console.log(qcHistoryRemarks, "qcHistoryRemarks")

  const managerId = !isEmpty(user) && user.roleId

  // console.log(managerId, "managerId details")

  const salesDetails = alter_quote_details

  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)
  // console.log(authUser, "authUser")
  // console.log(response, "response User")
  // console.log(responseLogin, "responseLogin")

  const loginAccess =
    !isEmpty(responseLogin) && responseLogin ? responseLogin : user

  const quotationMenu =
    !isEmpty(loginAccess) && loginAccess && loginAccess.menu
      ? loginAccess.menu.map((menu) => menu.menuId.menuSubHeader)
      : []
  const menuId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length > 2 &&
    quotationMenu[2] !== undefined
      ? quotationMenu[2].map((menu) => menu)
      : []
  const menuArrayId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length > 3 &&
    quotationMenu[3] !== undefined
      ? quotationMenu[3].map((menu) => menu)
      : []
  const menuQuotationId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length > 4 &&
    quotationMenu[4] !== undefined
      ? quotationMenu[4].map((menu) => menu)
      : []
  const menuMultipleId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length > 5 &&
    quotationMenu[5] !== undefined
      ? quotationMenu[5].map((menu) => menu)
      : []
  const menuLengthId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length === 7 &&
    quotationMenu[5] !== undefined
      ? quotationMenu[5].map((menu) => menu)
      : []
  const menuEightLengthId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length === 8 &&
    quotationMenu[5] !== undefined
      ? quotationMenu[5].map((menu) => menu)
      : []
  const menuNineLengthId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length === 9 &&
    quotationMenu[5] !== undefined
      ? quotationMenu[5].map((menu) => menu)
      : []
  const menuTenLengthId =
    !isEmpty(quotationMenu) &&
    quotationMenu.length === 10 &&
    quotationMenu[5] !== undefined
      ? quotationMenu[5].map((menu) => menu)
      : []

  const accessId =
    quotationMenu.length === 10
      ? menuTenLengthId.map((menu) => menu.access)
      : quotationMenu.length === 9
      ? menuNineLengthId.map((menu) => menu.access)
      : quotationMenu.length === 8
      ? menuEightLengthId.map((menu) => menu.access)
      : quotationMenu.length === 7
      ? menuLengthId.map((menu) => menu.access)
      : quotationMenu.length === 6
      ? menuMultipleId.map((menu) => menu.access)
      : quotationMenu.length === 5
      ? menuQuotationId.map((menu) => menu.access)
      : quotationMenu.length === 4
      ? menuArrayId.map((menu) => menu.access)
      : quotationMenu.length === 3
      ? menuId.map((menu) => menu.access)
      : []
  const qcApprove =
    accessId.length > 3
      ? accessId[3].map((access) => access)
      : accessId.length > 2
      ? accessId[2].map((access) => access)
      : accessId.length > 1
      ? accessId[1].map((access) => access)
      : accessId.length > 0
      ? accessId[0].map((access) => access)
      : []
  //Approval access
  const alterApproveDetails =
    qcApprove && qcApprove
      ? qcApprove.filter(
          (menu) =>
            menu._id === "6375ef14dcfc53245ce1b8ab" ||
            menu._id === "63a55e35b125090ff1d49df4"
        )
      : []
  const alterRecheckDetails =
    qcApprove && qcApprove
      ? qcApprove.filter(
          (menu) =>
            menu._id === "6375ef22dcfc53245ce1b8b1" ||
            menu._id === "63a55e42b125090ff1d4ab8e"
        )
      : []

  //  Accees Id from menu

  const qcAlterId =
    alterApproveDetails && alterApproveDetails.length > 0
      ? alterApproveDetails[0]._id
      : []
  const qcAlterRecheckId =
    alterRecheckDetails && alterRecheckDetails.length > 0
      ? alterRecheckDetails[0]._id
      : []

  // console.log(qcAlterId, qcAlterRecheckId, "access from user role")
  // console.log(qcApprove, "qcApprove")

  //Dropdown list ffrom Api
  const branchOptions =
    !isEmpty(alterQuoteMetaData) &&
    alterQuoteMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )

  const serviceOptions =
    !isEmpty(alterQuoteMetaData) &&
    alterQuoteMetaData.serviceOptions.filter(
      (service) => service.companyId && service.companyId[0] === company.value
    )

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)
  //fuse options in venue name
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  const editSalesApproval = (quote) => {
    setEditFlag(true)
    setLeadId(quote.leadId)
    setFullscreen(true)
    setApprovalDetails(quote)
  }

  useEffect(() => {
    if (editFlag === true) {
      setTimeout(() => {
        dispatch(quotationAction.loadQuotationPreview(leadId))
        dispatch(quotationAction.loadInstructions(leadId))
        dispatch(quotationAction.loadPhotography(leadId))
        dispatch(quotationAction.loadQcHistory(leadId))
        dispatch(quoteAction.loadAlterQuotePending())
        dispatch(quoteAction.loadAlterQuoteHistory(leadId))
      }),
        1000
    }
  }, [editFlag])

  let slNo = 0
  const quoteDataTable = !isEmpty(salesDetails)
    ? salesDetails.map((quote, index) => {
        const priority = get(quote, "priorityStatusName", "No status")
        slNo = slNo + 1

        var quotationDate = !isEmpty(quote.quotationDate)
          ? moment(quote.quotationDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []

        return {
          _id: quote._id,
          sNo: slNo,
          action: (
            <Button
              type="submit"
              style={{ fontSize: "8px" }}
              onClick={() => {
                editSalesApproval(quote)
              }}
              className="btn btn-success"
            >
              <i className="fas fa-edit icon-btn"></i>
            </Button>
          ),
          quotationId: quote.quotationId,
          quotationQcStatus: (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                quote.quotationQcStatus
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
              }`}
              pill
            >
              {quote.quotationQcStatus}
            </Badge>
          ),
          branchName: quote.branchName,
          alterMode: quote.quotationAlterMode,
          alterRemarks: quote.quotationAlterRemarks,
          alterStatus: (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                quote.alterStatus
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
              }`}
              pill
            >
              {quote.alterStatusName}
            </Badge>
          ),
          clientId: quote.clientId,
          clientNo: quote.clientNo,
          companyName: quote.companyName,
          companyId: quote.companyId,
          leadCode: quote.leadCode,
          leadId: quote.leadId,
          priorityStatusName: priority,
          assignedBy: quote.assignedBy,
          quotationDate: quotationDate,
          quotationNumber: quote.quotationNumber,
          reviseCount: quote.reviseCount,
          reviseType: quote.reviseType,
          key: index,
        }
      })
    : []

  //Client details functionality
  const clientProfile =
    !isEmpty(quotation_preview) && quotation_preview.broomGroomDetail
  const eventDetails =
    !isEmpty(quotation_preview) && quotation_preview.quotationDetails.events
  const quotationDetails =
    !isEmpty(quotation_preview) && quotation_preview.quotationDetails
  const deliverableDetails =
    !isEmpty(quotation_preview) &&
    quotation_preview.quotationDetails.deliverables
  const specialInstructions =
    !isEmpty(quotation_preview) && quotation_preview.specialInstruction
  const checkListDetails =
    !isEmpty(quotation_preview) && quotation_preview.checkList

  // console.log(clientProfile, "clientProfile")
  // console.log(eventDetails, "eventDetails")
  // console.log(specialInstructions, "specialInstructions")
  // console.log(checkListDetails, "checkListDetails")
  // console.log(eventDetails, "eventDetails")
  // console.log(serviceDetails, "serviceDetails")
  // console.log(deliverableDetails, "deliverableDetails")

  const eventDataTable = !isEmpty(eventDetails)
    ? eventDetails.map((events) => {
        let array = events.service
        var evenServiceArrayValue = []
        var oddServiceArrayValue = []

        for (var i = 0; i < array.length; i++) {
          if (i % 2 === 0) {
            oddServiceArrayValue.push(array[i])
          } else {
            evenServiceArrayValue.push(array[i])
          }
        }
        var eventDate = !isEmpty(events.eventDate)
          ? moment(events.eventDate).format(dateFormate)
          : // .subtract(5, "hours")
            // .subtract(30, "minutes")
            // .format(`${dateFormate} hh:mm A`)
            []
        return {
          _id: events.leadEventId,
          leadQuotationEventId: events.leadQuotationEventId,
          status: 1,
          eventName: events.eventName,
          event: events.event,
          eventNo: events.eventNo,
          startTime: events.startTime,
          endTime: events.endTime,
          eventType: events.eventType,
          eventTypeName: events.eventTypeName,
          eventDate: eventDate,
          crewAssemblyTime: events.crewAssemblyTime,
          venueLocation: events.venueLocation,
          venueName: events.venueName,
          venueId: events.venueId,
          food: events.food,
          travelStay: events.travelStay,
          crowdStrength: events.crowdStrength,
          totalUpselling: events.totalUpselling,
          totalValue: events.totalValue,
          totalDiscount: events.totalDiscount,
          totalAmount: events.totalAmount,
          services: array,
          oddServices: oddServiceArrayValue,
          evenServices: evenServiceArrayValue,
        }
      })
    : []

  const eventFinalAmount =
    !isEmpty(eventDetails) &&
    eventDetails
      .map((data) => data.totalAmount)
      .reduce((a, b) => {
        if (b === undefined) {
          return parseInt(a)
        } else if (a === undefined) {
          return parseInt(b)
        } else {
          return parseInt(a) + parseInt(b)
        }
      })

  // console.log(eventFinalAmount, "eventFinalAmount")
  const deliverFinalAmount =
    !isEmpty(deliverableDetails) &&
    deliverableDetails
      .map((data) => data.finalAmount)
      .reduce((a, b) => {
        if (b === undefined) {
          return parseInt(a)
        } else if (a === undefined) {
          return parseInt(b)
        } else {
          return parseInt(a) + parseInt(b)
        }
      })

  // console.log(deliverFinalAmount, "deliverFinalAmount")

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
    },
    {
      dataField: "leadCode",
      text: "Lead Code",
      sort: true,
      style: {
        textTransform: "uppercase",
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      headerStyle: {
        minWidth: "120px",
      },
      sort: true,
    },
    {
      dataField: "branchName",
      text: "Branch",
      headerStyle: {
        minWidth: "120px",
      },
      sort: true,
    },
    {
      dataField: "clientNo",
      text: "Client Code",
      headerStyle: {
        minWidth: "140px",
      },
      sort: true,
    },
    {
      dataField: "quotationNumber",
      text: "Quotation No",
      headerStyle: {
        minWidth: "140px",
      },
      sort: true,
    },
    {
      dataField: "quotationDate",
      text: "Quotation Date",
      headerStyle: {
        minWidth: "150px",
      },
      sort: true,
    },
    {
      dataField: "assignedBy",
      text: "Sales Agent",
      headerStyle: {
        minWidth: "150px",
      },
      sort: true,
    },
    {
      dataField: "priorityStatusName",
      text: "Priority Status",
      headerStyle: {
        minWidth: "150px",
      },
      sort: true,
    },
    {
      dataField: "alterMode",
      text: "Alter Mode",
      headerStyle: {
        minWidth: "130px",
      },
      sort: true,
    },
    {
      dataField: "alterRemarks",
      text: "Alter Remarks",
      headerStyle: {
        minWidth: "140px",
      },
      sort: true,
    },
    {
      dataField: "alterStatus",
      text: "Alter Status",
      headerStyle: {
        minWidth: "140px",
      },
      sort: true,
    },
  ]

  //Page Navigation to quotation-details
  // const [isLoading, setIsLoading] = useState(false)

  //Options base on company details

  const handleCompanyChange = (e) => {
    setCompany(e)

    var dataSales = quoteData
    dataSales.quotationFromDate = e ? "" : quoteData.quotationFromDate
    dataSales.quotationToDate = e ? "" : quoteData.quotationToDate
    setBranch([])
    setService([])
    setPriority([])
    setSalesAgent([])
  }

  // const editQcApprove = () => {
  //   setIsLoading(true)
  // }

  const [salesAgent, setSalesAgent] = useState([])

  const handleApply = () => {
    var searchCompany = company && company.value ? company.value : ""
    var searchBranch = branch && branch.value ? branch.value : ""
    var searchService = service && service.value ? service.value : ""
    var searchEmpCode =
      salesAgent && salesAgent.empCode ? salesAgent.empCode : ""
    var searchPriority = priority && priority.value ? priority.value : ""

    var searchFromDate =
      quoteData && quoteData.quotationFromDate
        ? quoteData.quotationFromDate
        : ""
    var searchToDate =
      quoteData && quoteData.quotationToDate ? quoteData.quotationToDate : ""

    var searchValue = {}
    if (searchCompany) {
      searchValue.companyId = searchCompany
    }
    if (searchBranch) {
      searchValue.branchId = searchBranch
    }
    if (searchService) {
      searchValue.serviceId = searchService
    }
    if (searchPriority) {
      searchValue.priorityStatus = searchPriority
    }
    if (searchEmpCode) {
      searchValue.empCode = searchEmpCode
    }
    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }

    // console.log("searchCompany", searchValue)
    specificDispatch(quoteAction.loadAlterQuotePending(searchValue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }
  const qcId =
    !isEmpty(approvalDetails) && approvalDetails ? approvalDetails._id : []
  //Alter quote functionality
  const alterQuoteApprove = () => {
    const alterQuoteData = {
      alterId: qcId,
      remarks: alterRemarks,
      alterStatus: "PS17",
    }
    specificDispatch(quoteAction.updateAlterQuote(alterQuoteData))
    setEditFlag(false)
    setTimeout(() => {
      specificDispatch(quoteAction.loadAlterQuotePending())
      setAlterRemarks("")
    }, 2000)
    // console.log(alterQuoteData, "qcRequestData")
  }

  const alterQuoteRecheck = () => {
    const alterQuoteData = {
      alterId: qcId,
      remarks: alterRemarks,
      alterStatus: "PS18",
    }

    specificDispatch(quoteAction.updateAlterQuote(alterQuoteData))
    setEditFlag(false)
    setTimeout(() => {
      specificDispatch(quoteAction.loadAlterQuotePending())
      setAlterRemarks("")
    }, 2000)
    // console.log(alterQuoteData, "qcRequestData")
  }

  const options = {
    sizePerPage: 10,
    totalSize: alter_quote_details.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  return (
    <React.Fragment>
      {editFlag ? (
        <Modal show={editFlag} onHide={handleModal} fullscreen={fullscreen}>
          <Modal.Header
            style={{
              backgroundColor: "white",
              color: "Black",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <Col xl="12" md="12" lg="12" sm="12" xs="12">
              <div className="sales-modal-header">
                <h4
                  className="modal-title mt-0 sales-modal-title"
                  id="myModalLabel"
                >
                  Edit Quotation Approvals
                </h4>
                <span>
                  <i
                    className="fa fa-times quote-close"
                    aria-hidden="true"
                    onClick={() => setEditFlag(false)}
                  ></i>
                </span>
              </div>
              {/* Render Breadcrumb */}
            </Col>
          </Modal.Header>
          <Modal.Body>
            <Col xl="12" lg="12" md="12" className="mt-3 mb-3">
              <Row>
                <Col
                  lg="3"
                  md="6"
                  sm="6"
                  xs="12"
                  className="total-package-value-section"
                  style={{ backgroundColor: "#f46a6a" }}
                >
                  <div className="quote-value-content">
                    <h2 className="value-title">Actual Value</h2>
                    <h1 className="quote-value-total">
                      Rs.{" "}
                      {!isEmpty(quotation_preview) &&
                      quotation_preview.actualAmountWithoutInsertValue
                        ? quotation_preview.actualAmountWithoutInsertValue
                        : 0}
                    </h1>
                  </div>
                </Col>
                <Col
                  lg="3"
                  md="6"
                  sm="6"
                  xs="12"
                  className="total-package-value-section"
                  style={{ backgroundColor: "#34aadc" }}
                >
                  <div className="quote-value-content">
                    <h2 className="value-title">Insert Value</h2>
                    <h1 className="quote-value-total">
                      Rs.{" "}
                      {!isEmpty(quotation_preview) &&
                      quotation_preview.insertedTotalAmount
                        ? quotation_preview.insertedTotalAmount
                        : 0}
                    </h1>
                  </div>
                </Col>
                <Col
                  lg="3"
                  md="6"
                  sm="6"
                  xs="12"
                  className="total-package-value-section"
                >
                  <div className="quote-value-content">
                    <h2 className="value-title">Total Value</h2>
                    <h1 className="quote-value-total">
                      Rs.{" "}
                      {!isEmpty(quotation_preview) &&
                        quotation_preview.totalPackage}
                    </h1>
                  </div>
                </Col>
                <Col
                  lg="3"
                  md="6"
                  sm="6"
                  xs="12"
                  className="total-value-section-upselling"
                  style={{ backgroundColor: "#34c28f", marginBottom: "4px" }}
                >
                  <div className="quote-value-content">
                    <h2 className="value-title">Upselling</h2>
                    <h1 className="quote-value-total">
                      Rs.{" "}
                      {!isEmpty(quotation_preview) &&
                        quotation_preview.upselling}{" "}
                    </h1>
                  </div>
                </Col>
                <Col
                  lg="3"
                  md="6"
                  sm="6"
                  xs="12"
                  className="total-value-section"
                  style={{ backgroundColor: "#f46a6a", marginBottom: "4px" }}
                >
                  <div className="quote-value-content">
                    <h2 className="value-title">Discount</h2>
                    <h1 className="quote-value-total d-flex flex-row justify-content-center">
                      Rs.{" "}
                      <span>
                        {!isEmpty(quotation_preview) &&
                          quotation_preview.discount}
                      </span>{" "}
                      <span>
                        (
                        {!isEmpty(quotation_preview) &&
                        quotation_preview.discountPercentage
                          ? Math.round(quotation_preview.discountPercentage) +
                            "%"
                          : "0 %"}
                        )
                      </span>
                    </h1>
                  </div>
                </Col>
                <Col
                  lg="3"
                  md="6"
                  sm="6"
                  xs="12"
                  className="total-value-section-payable"
                  style={{ marginBottom: "4px" }}
                >
                  <div className="quote-value-content">
                    <h2 className="value-title">Total Payable</h2>
                    <h1 className="quote-value-total">
                      Rs.{" "}
                      {!isEmpty(quotation_preview) &&
                        quotation_preview.packageValue}{" "}
                    </h1>
                  </div>
                </Col>
              </Row>
            </Col>
            {/* Approval section qc */}
            <Col md="12" xl="12" lg="12" xs="12" sm="12">
              <Row>
                <Col
                  md="12"
                  xl="6"
                  lg="6"
                  xs="12"
                  sm="12"
                  className="approval-details-grid"
                >
                  <Row>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content mt-2"
                    >
                      <p className="approval-details-title">Company Name</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(approvalDetails) && approvalDetails
                          ? approvalDetails.companyName
                          : "No Company Name"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content mt-2"
                    >
                      <p className="approval-details-title">Branch Name</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(approvalDetails) && approvalDetails
                          ? approvalDetails.branchName
                          : "No Branch Name"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content mt-2"
                    >
                      <p className="approval-details-title">Lead Source</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(quotation_preview) && quotation_preview
                          ? quotation_preview.leadSourceName
                          : "No LeadSource"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content"
                    >
                      <p className="approval-details-title">Lead No</p>
                      <h1 className="approval-details-lead-subtitle">
                        {!isEmpty(approvalDetails) && approvalDetails
                          ? approvalDetails.leadCode
                          : "No Lead No "}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content"
                    >
                      <p className="approval-details-title">Lead Date</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(approvalDetails) && approvalDetails
                          ? moment(approvalDetails.leadDate).format(
                              `${dateFormate} hh:mm A`
                            )
                          : "No Lead Date"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content"
                    >
                      <p className="approval-details-title">Priority</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(approvalDetails) && approvalDetails
                          ? approvalDetails.priorityStatusName
                          : "No Priority"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content mt-3"
                    >
                      <p className="approval-details-title">Sales Agent Name</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(approvalDetails) && approvalDetails
                          ? approvalDetails.assignedBy
                          : "No Sales Agent Name"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content mt-3"
                    >
                      <p className="approval-details-title">Lead Status</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(quotation_preview) && quotation_preview
                          ? quotation_preview.leadStatus
                          : "No Lead status"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="12"
                      sm="12"
                      className="approval-detail-content mt-3"
                    >
                      <p className="approval-details-title">Sales Urge</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(approvalDetails) && approvalDetails
                          ? approvalDetails.salesUrge
                          : "No Sales Urge"}
                      </h1>
                    </Col>
                  </Row>
                </Col>

                {/* Revise Details qc */}
                <Col
                  md="12"
                  xl="6"
                  lg="6"
                  xs="12"
                  sm="12"
                  className="qc-approval-details-grid"
                >
                  <Row>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="4"
                      sm="4"
                      className="qc-approval-detail-content mt-2"
                    >
                      <p className="approval-details-title">Quotation No</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(quotationDetails) && quotationDetails
                          ? quotationDetails.quotationNumber
                          : "No Quotation No"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="4"
                      sm="4"
                      className="qc-approval-detail-content mt-2"
                    >
                      <p className="approval-details-title">Quotation Date</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(quotationDetails) && quotationDetails
                          ? moment(quotationDetails.quotationDate)
                              .subtract(5, "hours")
                              .subtract(30, "minutes")
                              .format(dateFormate)
                          : "No Quotation Date"}
                      </h1>
                    </Col>
                    <Col
                      md="4"
                      xl="4"
                      lg="4"
                      xs="4"
                      sm="4"
                      className="qc-approval-detail-content mt-2"
                    >
                      <p className="approval-details-title">Quotation Revise</p>
                      <h1 className="approval-details-subtitle">
                        {!isEmpty(qc_history) && qc_history.reviseCount
                          ? qc_history.reviseCount
                          : ""}
                      </h1>
                    </Col>

                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                      xs="12"
                      className="d-flex flex-column mt-3"
                    >
                      <div className="d-flex flex-row justify-content-between">
                        <Label
                          className="event-label"
                          style={{ marginBottom: "-10px" }}
                        >
                          Request Remarks
                        </Label>
                        <Col className="qc-approval-buttons-section mb-2">
                          <button
                            className={"qc-button-history"}
                            onClick={() => setHistoryForm(true)}
                          >
                            Qc History
                          </button>

                          <button
                            className={
                              quotation_preview.leadStatus === "PS17" ||
                              managerId === "6320da65812dfec5383565f4"
                                ? "qc-button-alter disabled-button"
                                : "qc-button-alter"
                            }
                            onClick={() => setAlterHistoryForm(true)}
                          >
                            Alter Quote History
                          </button>
                        </Col>
                      </div>
                      <textarea
                        type="text"
                        name="alterRemarks"
                        value={qcHistoryRemarks}
                        placeholder="Enter Remarks"
                        className="event-crowd-textarea"
                        disabled
                      />
                    </Col>
                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="12"
                      xs="12"
                      className="d-flex flex-column mt-3"
                    >
                      <div className="d-flex flex-row justify-content-between">
                        <Label
                          className="event-label"
                          style={{ marginBottom: "14px" }}
                        >
                          Remarks
                        </Label>
                      </div>
                      <textarea
                        type="text"
                        name="alterRemarks"
                        value={alterRemarks}
                        onChange={(e) => setAlterRemarks(e.target.value)}
                        placeholder="Enter Remarks"
                        className={
                          editFlag
                            ? "event-crowd-textarea"
                            : "event-crowd-textarea disabled-button"
                        }
                      />
                    </Col>
                    <Col
                      lg="12"
                      xl="12"
                      md="12"
                      sm="12"
                      xs="12"
                      className="qc-approval-buttons-section mt-2 mb-2"
                    >
                      {qcAlterId === "6375ef14dcfc53245ce1b8ab" ||
                      qcAlterId === "63a55e35b125090ff1d49df4" ? (
                        <button
                          className={"qc-button-approve"}
                          onClick={() => setAlterApprovalView(true)}
                        >
                          ALTER QUOTE APPROVE
                        </button>
                      ) : (
                        ""
                      )}
                      {
                        // reject
                        qcAlterRecheckId === "6375ef22dcfc53245ce1b8b1" ||
                        qcAlterRecheckId === "63a55e42b125090ff1d4ab8e" ? (
                          <button
                            className={"qc-button-recheck"}
                            onClick={() => {
                              setAlterRecheckView(true)
                            }}
                          >
                            ALTER QUOTE REJECT
                          </button>
                        ) : (
                          ""
                        )
                      }
                    </Col>

                    {historyForm && (
                      <Modal
                        show={historyForm}
                        onHide={handleHistoryClose}
                        style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                        size="lg"
                      >
                        <Modal.Header>Quotation QC History</Modal.Header>
                        <Modal.Body>
                          <Table>
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Revised Type</th>
                                <th>Responsed By</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(qc_history.reviseList) &&
                              qc_history.reviseList.length > 0 ? (
                                qc_history.reviseList.map((history) => {
                                  var quotationDate = !isEmpty(
                                    history.quotationDate
                                  )
                                    ? moment(history.quotationDate)
                                        .subtract(5, "hours")
                                        .subtract(30, "minutes")
                                        .format(`${dateFormate} hh:mm A`)
                                    : []

                                  return (
                                    <tr key={history._id}>
                                      <td>{quotationDate}</td>
                                      <td
                                        style={{ textTransform: "uppercase" }}
                                      >
                                        {history.quotationQcMode}
                                      </td>
                                      <td>{history.responsedBy}</td>
                                      <td>{history.remarks}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <>
                                  <tr key={0}>
                                    <td
                                      colSpan={4}
                                      className="text-align-center"
                                    >
                                      No record found
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </Table>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleHistoryClose}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}
                    {alterHistoryForm && (
                      <Modal
                        show={alterHistoryForm}
                        onHide={handleAlterHistoryClose}
                        style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                        size="lg"
                      >
                        <Modal.Header>Alter Quote History</Modal.Header>
                        <Modal.Body>
                          <Table>
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Revised Type</th>
                                <th>Responsed By</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(alter_quote_history) &&
                              alter_quote_history.length > 0 ? (
                                alter_quote_history.map((history) => {
                                  var quotationDate = !isEmpty(
                                    history.quotationDate
                                  )
                                    ? moment(history.quotationDate)
                                        .subtract(5, "hours")
                                        .subtract(30, "minutes")
                                        .format(`${dateFormate} hh:mm A`)
                                    : []

                                  return (
                                    <tr key={history._id}>
                                      <td>{quotationDate}</td>
                                      <td
                                        style={{ textTransform: "uppercase" }}
                                      >
                                        {history.mode}
                                      </td>
                                      <td>{history.alterResponsedBy}</td>
                                      <td>{history.remarks}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <>
                                  <tr key={0}>
                                    <td
                                      colSpan={4}
                                      className="text-align-center"
                                    >
                                      No record found
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </Table>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleAlterHistoryClose}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}
                    {/* //Alter quote modal View */}
                    {alterApprovalView && (
                      <Modal
                        show={alterApprovalView}
                        onHide={handleAlterClose}
                        style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                      >
                        <Modal.Header>Alter the QC</Modal.Header>
                        <Modal.Body>
                          Are you sure you want to Alter the QC?
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleAlterClose}
                          >
                            Close
                          </Button>
                          <Button
                            variant="primary"
                            className="btn btn-success"
                            onClick={() => {
                              handleAlterClose()
                              alterQuoteApprove()
                            }}
                          >
                            Submit
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}
                    {/* //Alter Recheck modal View */}
                    {alterRecheckView && (
                      <Modal
                        show={alterRecheckView}
                        onHide={handleAlterRecheckClose}
                        style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                      >
                        <Modal.Header>Recheck the Alter Quote</Modal.Header>
                        <Modal.Body>
                          Are you sure you want to Recheck the Alter Quote?
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleAlterRecheckClose}
                          >
                            Close
                          </Button>
                          <Button
                            variant="primary"
                            className="btn btn-success"
                            onClick={() => {
                              handleAlterRecheckClose()
                              alterQuoteRecheck()
                            }}
                          >
                            Recheck
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}
                  </Row>
                </Col>
              </Row>
              {/* Recheck section end */}
            </Col>
            {/* Client details section */}

            <Col md="12" xl="12" lg="12" sm="12" xs="12" className="mt-3 mb-3">
              <p className="quote-head">CLIENT DETAILS</p>
            </Col>
            {/* Data Table Section */}
            <Col md="12" lg="12" xl="12">
              <Table bordered striped responsive>
                <thead style={{ fontWeight: "550" }}>
                  <tr style={{ fontSize: "10px" }}>
                    <td>Bride / Groom</td>
                    <td>Mobile No</td>
                    <td>Whats App</td>
                    <td>Email Id</td>
                    <td>Profile</td>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(clientProfile) && clientProfile.length > 0 ? (
                    clientProfile.map((client) => {
                      return (
                        <tr className="bg-white" key={client._id}>
                          <td className="qc-client-profile">
                            {client.bride.brideName}
                            <span className="sales-client-profile">
                              (Bride)
                            </span>
                          </td>
                          <td className="qc-client-profile">
                            {client.bride.brideMobileNo}
                          </td>
                          <td className="qc-client-profile">
                            {client.bride.brideWhatsappNo}
                          </td>
                          <td className="qc-client-profile">
                            {client.bride.brideEmailId}
                          </td>
                          <td className="qc-client-profile">
                            {client.bride.brideProfile}
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <>
                      <tr key={0}>
                        <td colSpan={11} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    </>
                  )}
                  {!isEmpty(clientProfile) && clientProfile.length > 0 ? (
                    clientProfile.map((client) => {
                      return (
                        <tr className="bg-white" key={client._id}>
                          <td className="qc-client-profile">
                            {client.groom.groomName}
                            <span className="sales-client-profile">
                              (Groom)
                            </span>
                          </td>
                          <td className="qc-client-profile">
                            {client.groom.groomMobileNo}
                          </td>
                          <td className="qc-client-profile">
                            {client.groom.groomWhatsappNo}
                          </td>
                          <td className="qc-client-profile">
                            {client.groom.groomEmailId}
                          </td>
                          <td className="qc-client-profile">
                            {client.groom.groomProfile}
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <>
                      <tr key={0}>
                        <td colSpan={11} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col>
            <Col md="12" xl="12" lg="12" sm="12" xs="12" className="mt-3 mb-3">
              <p className="quote-head">VALUE INSERT DETAILS</p>
            </Col>
            {/* Data Table Section */}
            <Col md="12" lg="12" xl="12">
              <Table bordered striped responsive>
                <thead style={{ fontWeight: "550" }}>
                  <tr style={{ fontSize: "12px" }}>
                    <td>Inserted Amount</td>
                    <td>Inserted Percentage</td>
                    <td>Inserted Total Amount</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="qc-client-profile">
                      {quotation_preview.insertedAmount}
                    </td>
                    <td className="qc-client-profile">
                      {quotation_preview.insertedPercentageAmount}
                    </td>
                    <td className="qc-client-profile">
                      {quotation_preview.insertedTotalAmount}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            {/* Event Details */}
            <Col md="12" xl="12" lg="12" sm="12" xs="12" className="mt-3 mb-3">
              <p className="quote-head">EVENT DETAILS</p>
            </Col>
            <Col lg="12" md="12" xl="12" className="mt-3">
              <div className="table-event-main">
                <Row>
                  <Col lg="12" md="12" xl="12">
                    <Table bordered striped responsive>
                      <thead>
                        <tr style={{ fontSize: "10px" }}>
                          {/* <th>S.No</th> */}
                          <th>Event No</th>
                          <th>Event Name</th>
                          <th style={{ minWidth: "84px" }}>Event Type</th>
                          <th style={{ minWidth: "103px" }}>Event Date</th>
                          <th style={{ minWidth: "84px" }}>Start Time</th>
                          <th style={{ minWidth: "78px" }}>End Time</th>
                          <th style={{ minWidth: "132px" }}>
                            Crew Assembly Time
                          </th>
                          <th style={{ minWidth: "105px" }}>Venue Location</th>
                          <th style={{ minWidth: "100px" }}>Venue Name</th>
                          <th>Food</th>
                          <th style={{ minWidth: "93px" }}>Travel Stay</th>
                          <th style={{ minWidth: "106px" }}>Crowd Strength</th>
                          <th style={{ minWidth: "84px" }}>Total Value</th>
                          <th style={{ minWidth: "102px" }}>Total Upselling</th>
                          <th>Discount</th>
                          <th style={{ minWidth: "100px" }}>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {eventDataTable && eventDataTable.length > 0 ? (
                          eventDataTable.map((events) => {
                            // console.log(events, "events")
                            return (
                              <>
                                <tr key={events._id}>
                                  <td
                                    className="event-style"
                                    style={{ color: "#e40d8c" }}
                                  >
                                    {events.eventNo}
                                  </td>
                                  <td>{events.eventName}</td>
                                  <td>{events.eventTypeName}</td>
                                  <td>{events.eventDate}</td>
                                  <td>{events.startTime}</td>
                                  <td>{events.endTime}</td>
                                  <td>{events.crewAssemblyTime}</td>
                                  <td>{events.venueLocation}</td>
                                  <td>{events.venueName}</td>
                                  <td>
                                    {!isEmpty(events.food) ? events.food : "--"}
                                  </td>
                                  <td>
                                    {!isEmpty(events.travelStay)
                                      ? events.travelStay
                                      : "--"}
                                  </td>
                                  <td>{events.crowdStrength}</td>
                                  <td>{events.totalValue}</td>
                                  <td>{events.totalUpselling}</td>
                                  <td>{events.totalDiscount}</td>
                                  <td>{events.totalAmount}</td>
                                </tr>

                                <tr>
                                  <td colSpan={8}>
                                    <Table>
                                      <thead>
                                        <tr>
                                          <th className="table-event-title">
                                            Service Name
                                          </th>
                                          <th className="table-event-title">
                                            Value
                                          </th>
                                          <th className="table-amount">
                                            Quantity
                                          </th>
                                          <th className="table-amount">
                                            Total Value
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {!isEmpty(events.oddServices) ? (
                                          events.oddServices.map((service) => {
                                            return (
                                              <tr
                                                className="table-row"
                                                key={service._id}
                                              >
                                                <td className="table-data">
                                                  {service.serviceName}
                                                </td>
                                                <td className="table-data">
                                                  {service.amount}
                                                </td>
                                                <td className="table-data">
                                                  {service.quantity}
                                                </td>
                                                <td className="table-data">
                                                  {service.totalAmount}
                                                </td>
                                              </tr>
                                            )
                                          })
                                        ) : (
                                          <>
                                            {" "}
                                            <tr key={0}>
                                              <td
                                                colSpan={4}
                                                className="text-align-center"
                                              >
                                                {"No Data Found"}
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                      </tbody>
                                    </Table>
                                  </td>

                                  <td colSpan={8}>
                                    <Table>
                                      <thead>
                                        <tr>
                                          <th className="table-event-title">
                                            Service Name
                                          </th>
                                          <th className="table-event-title">
                                            value
                                          </th>
                                          <th className="table-amount">
                                            Quantity
                                          </th>
                                          <th className="table-amount">
                                            TotalValue
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {!isEmpty(events.evenServices) ? (
                                          events.evenServices.map((service) => {
                                            return (
                                              <tr
                                                className="table-row"
                                                key={service._id}
                                              >
                                                <td className="table-data">
                                                  {service.serviceName}
                                                </td>
                                                <td className="table-data">
                                                  {service.amount}
                                                </td>
                                                <td className="table-data">
                                                  {service.quantity}
                                                </td>
                                                <td className="table-data">
                                                  {service.totalAmount}
                                                </td>
                                              </tr>
                                            )
                                          })
                                        ) : (
                                          <>
                                            {" "}
                                            <tr key={0}>
                                              <td
                                                colSpan={4}
                                                className="text-align-center"
                                              >
                                                {"No Data Found"}
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <>
                            {" "}
                            <tr key={0}>
                              <td colSpan={15} className="text-align-center">
                                {"No Data Found"}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg="12" md="12" xl="12" className="mt-3 mb-3">
              <h1 className="total-qc-value">
                Total Value :{" "}
                <span className="event-qc-total">
                  Rs. {!eventFinalAmount ? "0.00" : eventFinalAmount + ".00"}
                </span>
              </h1>
            </Col>
            {/* Deliverables Details */}
            <Col lg="12" md="12" xl="12" className="quote-head-content mt-3">
              <p className="quote-head">DELIVERABLES DETAILS</p>
            </Col>
            <Col md="12" lg="12" xl="12">
              <Table striped responsive className="w-100 mt-3 mb-2">
                <thead>
                  <tr style={{ fontSize: "10px" }}>
                    <th>S.No</th>
                    <th>Event Name</th>
                    <th>Event No</th>
                    <th>Mode</th>
                    <th>Deliverable Type</th>
                    <th>Product Name</th>
                    <th>Count/Sheet</th>
                    <th>Qty</th>
                    <th>Quoted</th>
                    <th>Discount</th>
                    <th>Upselling</th>
                    <th>Final Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {deliverableDetails && deliverableDetails.length > 0 ? (
                    deliverableDetails.map((deliverable, index) => {
                      const quotePrice = get(
                        deliverable,
                        "quotePrice",
                        "No Quote Price"
                      )
                      const discount = get(
                        deliverable,
                        "discount",
                        "No Discount"
                      )
                      const upselling = get(
                        deliverable,
                        "upselling",
                        "No Upselling"
                      )
                      const finalAmount = get(
                        deliverable,
                        "finalAmount",
                        "No FinalAmount"
                      )
                      return (
                        <tr key={deliverable._id}>
                          <td>{index + 1}</td>
                          <td>{deliverable.eventName}</td>
                          <td>
                            {" "}
                            {!isEmpty(deliverable) &&
                            deliverable.eventNo &&
                            deliverable.eventNo.length > 0
                              ? deliverable.eventNo.join(" , ")
                              : deliverable.eventNo}
                          </td>
                          <td>{deliverable.mode}</td>
                          <td>{deliverable.deliverableType}</td>
                          <td>{deliverable.productName}</td>
                          <td>{deliverable.count}</td>
                          <td>{deliverable.quantity}</td>
                          <td>{quotePrice}</td>
                          <td>{discount}</td>
                          <td>{upselling}</td>
                          <td>{finalAmount}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <>
                      {" "}
                      <tr key={0}>
                        <td colSpan={12} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col>
            <Col lg="12" md="12" xl="12" className="mt-3 mb-3">
              <h1 className="total-qc-value">
                Total Value :{" "}
                <span className="event-qc-total">
                  {" "}
                  {!deliverFinalAmount ? "0.00" : deliverFinalAmount + ".00"}
                </span>
              </h1>
            </Col>

            {/* Special Instructions */}
            <Col lg="12" md="12" xl="12" className="quote-head-content mt-3">
              <p className="quote-head">SPECIAL INSTRUCTIONS</p>
            </Col>
            <Col md="12" lg="12" xl="12">
              <Table striped responsive className="w-100 mt-3 mb-2">
                <thead>
                  <tr style={{ fontSize: "10px" }}>
                    <th>S.No</th>
                    <th>Department</th>
                    <th>Team</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {specialInstructions && specialInstructions.length > 0 ? (
                    specialInstructions.map((instruction, index) => {
                      return (
                        <>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{instruction.departmentName}</td>
                            <td>{instruction.teamName}</td>
                            <td>{instruction.remarks}</td>
                          </tr>
                        </>
                      )
                    })
                  ) : (
                    <>
                      {" "}
                      <tr key={0}>
                        <td colSpan={12} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col>
            {/* Event checklist */}
            <Col lg="12" md="12" xl="12" className="quote-head-content">
              <p className="quote-head">PHOTOGRAPHY EVENT CHECKLIST</p>
            </Col>
            <Col md="12" lg="12" xl="12">
              <Table striped responsive className="w-100 mt-3 mb-2">
                <thead>
                  <tr style={{ fontSize: "10px" }}>
                    <th>S.No</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {checkListDetails && checkListDetails.length > 0 ? (
                    checkListDetails.map((instruction, index) => {
                      return (
                        <>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{instruction.description}</td>
                          </tr>
                        </>
                      )
                    })
                  ) : (
                    <>
                      {" "}
                      <tr key={0}>
                        <td colSpan={12} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <div className="alter-quote-main-content">
          <Row>
            {/* Sales approval Head */}
            <Col xl="12" lg="12" md="12" sm="12" xs="12">
              <Row>
                <Col xl="12" md="12" lg="12" sm="12" xs="12">
                  <MetaTags>
                    <title style={{ textTransform: "uppercase" }}>
                      {title} | Zero Gravity CRM
                    </title>
                  </MetaTags>
                  {/* Render Breadcrumb */}
                  <Breadcrumbs title={"Approvals"} breadcrumbItem={title} />
                </Col>
                <Col
                  xl="12"
                  md="12"
                  lg="12"
                  sm="12"
                  xs="12"
                  className="sales-approval-card"
                >
                  <Row className="alter-quote-main-form">
                    <Col className="mt-2 mb-2">
                      <Row className="">
                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Company</Label>
                          <Select
                            name="company"
                            value={company}
                            onChange={(e) => handleCompanyChange(e)}
                            options={
                              alterQuoteMetaData
                                ? alterQuoteMetaData.companyOptions
                                : ""
                            }
                          />
                        </Col>
                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Branch</Label>
                          <Select
                            name="branch"
                            value={branch}
                            onChange={(e) => setBranch(e)}
                            options={branchOptions}
                          />
                        </Col>
                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Service</Label>
                          <Select
                            name="service"
                            value={service}
                            onChange={(e) => setService(e)}
                            options={serviceOptions}
                          />
                        </Col>
                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Priority</Label>
                          <Select
                            name="priority"
                            value={priority}
                            onChange={(e) => setPriority(e)}
                            options={
                              alterQuoteMetaData
                                ? alterQuoteMetaData.priorityOptions
                                : ""
                            }
                          />
                        </Col>
                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">Sales Agent</Label>
                          <ReactSearchAutocomplete
                            name="salesAgent"
                            items={agentOptions}
                            value={salesAgent}
                            type="autoComplete"
                            resultStringKeyName="label"
                            showIcon={false}
                            onSelect={(e) => setSalesAgent(e)}
                            // onChange={(e) => setSalesAgent(e.target.value)}
                            placeholder="Enter Sales Agent"
                            fuseOptions={fuseOptions} // Search on both fields
                            styling={{
                              height: "34px",
                              border: "1px solid #ced4da",
                              borderRadius: "4px",
                              backgroundColor: "white",
                              boxShadow: "none",
                              hoverBackgroundColor: "#E40D8C",
                              color: "black",
                              fontSize: "12px",
                              fontFamily: "Courier",
                              iconColor: "green",
                              clearIconMargin: "3px 8px 0 0",
                            }}
                          />
                        </Col>
                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">From Date</Label>
                          <Input
                            type="date"
                            name="quotationFromDate"
                            value={quoteData.quotationFromDate}
                            onChange={(e) => handleChange(e)}
                            placeholder="Select Date"
                          />
                        </Col>
                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                          <Label className="event-label">To Date</Label>
                          <Input
                            type="date"
                            name="quotationToDate"
                            value={quoteData.quotationToDate}
                            onChange={(e) => handleChange(e)}
                            placeholder="Select Date"
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      xl="12"
                      lg="12"
                      md="12"
                      //   className="sales-approval-filter"
                    >
                      <button
                        type="button"
                        className="btn btn-success btn-label form-submit-btn sales-approval-filter"
                        onClick={() => handleApply()}
                      >
                        <i
                          className="fas fa-check-double label-icon"
                          style={{ fontSize: "12px" }}
                        ></i>
                        {btnLoader && btnLoader ? (
                          <ButtonSpinner />
                        ) : (
                          "Apply Filter"
                        )}{" "}
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col className="sales-approval-card mt-4">
              <Row className="alter-quote-main-form">
                <Col className="h-100 mt-3">
                  <PaginationProvider
                    pagination={paginationFactory(options)}
                    keyField="_id"
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={quoteDataTable}
                        columns={columns}
                        search
                      >
                        {(props) => (
                          <div>
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <Row className="d-flex flex-column">
                                <Col className="mb-3">
                                  <SearchBar {...props.searchProps} />
                                </Col>
                                <Col>
                                  <BootstrapTable
                                    {...props.baseProps}
                                    responsive
                                    striped={true}
                                    {...paginationTableProps}
                                    bordered={true}
                                  />
                                </Col>
                              </Row>
                              <Row
                                style={{ marginTop: "5px" }}
                                className="align-items-md-center mt-30"
                              >
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline d-flex flex-row">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "8px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      <PaginationTotalStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="text-md-right ms-auto"
                                    style={{ zIndex: 0 }}
                                  >
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </React.Fragment>
  )
}

AlterQuote.propTypes = {
  dispatch: PropTypes.func,
  sales_details: PropTypes.array,
  employee_list: PropTypes.array,
  recordsMetaData: PropTypes.object,
  alterQuoteMetaData: PropTypes.object,
  salesRecordsMetaData: PropTypes.object,
  records: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
}

const mapStateToProps = (state) => ({
  sales_details: state.quotation.sales_details,
  employee_list: state.quotation.employee_list,
})

/**
 *
 * @param {function} dispatch
 * @returns
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AlterQuote)
)
